export default __webpack_public_path__ + "static/media/emailviewv2.6e03318a.png";